import { Flex } from '@chakra-ui/react';
import React from 'react';

// Constants
const SUBHEADER_ELEMENT_ID = 'finley-subheader';

// Hooks
/**
 * Some routes have 2 headers. They use the `div#finley-subheader` DOM element to render the
 * secondary header as a React Portal. This allows subroutes to inject their subheader into the
 * global nav, and subroute subheaders can still use subroute contexts.
 */
export const useSubheaderDomNode = () =>
  document.getElementById(SUBHEADER_ELEMENT_ID);

// Exports
type LayoutWithSidebarProps = {
  children: React.ReactNode;
  header: React.ReactNode;
  globalNav: React.ReactNode;
  pageHeader?: React.ReactNode;
  subHeader?: React.ReactNode;
};
export const LayoutWithSidebar = ({
  children,
  header,
  globalNav,
  pageHeader = null,
  subHeader = <div id={SUBHEADER_ELEMENT_ID} />,
}: LayoutWithSidebarProps) => (
  <Flex direction="column" height="100vh" width="100vw">
    <Flex id="finley-header" as="header" direction="column">
      {header}
      {subHeader}
    </Flex>
    <Flex direction="row" flexGrow={1} overflow="hidden">
      {globalNav}
      <Flex direction="column" flexGrow={1} overflow="hidden">
        {pageHeader}
        <Flex direction="row" overflow="hidden">
          <Flex as="main" direction="column" flexGrow={1} overflow="auto">
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);
